/**
 * IONLOOP Assistant — lightweight conversation timeline & context manager.
 *
 * Session-only memory (a browser refresh resets it). Each exchange stores
 * semantic metadata, never rendered HTML. No localStorage, no persistence.
 */

var MAX_EXCHANGES = 14;

function createConversation() {
    var exchanges = [];

    return {
        /**
         * Record one exchange.
         * @param {Object} ex semantic metadata (query, primaryEntity, ...)
         * @returns {number} the exchange id
         */
        addExchange: function (ex) {
            var exchange = Object.assign({}, ex);
            exchange.id = exchanges.length + 1;
            exchange.timestamp = Date.now();
            exchanges.push(exchange);
            if (exchanges.length > MAX_EXCHANGES) {
                exchanges.shift();
            }
            return exchange.id;
        },

        getExchanges: function () {
            return exchanges.slice();
        },

        getLast: function () {
            return exchanges.length ? exchanges[exchanges.length - 1] : null;
        },

        getPrimaryEntity: function () {
            for (var i = exchanges.length - 1; i >= 0; i -= 1) {
                if (exchanges[i].primaryEntity) {
                    return exchanges[i].primaryEntity;
                }
            }
            return null;
        },

        getRecentCategory: function () {
            for (var i = exchanges.length - 1; i >= 0; i -= 1) {
                if (exchanges[i].category) {
                    return exchanges[i].category;
                }
            }
            return null;
        },

        getEntities: function () {
            var out = [];
            var seen = {};
            exchanges.forEach(function (ex) {
                [ex.primaryEntity].concat(ex.entities || []).forEach(function (e) {
                    if (e && !seen[e]) {
                        seen[e] = true;
                        out.push(e);
                    }
                });
            });
            return out;
        },

        getComparisonEntities: function () {
            for (var i = exchanges.length - 1; i >= 0; i -= 1) {
                var c = exchanges[i].comparisonEntities;
                if (c && c.length) {
                    return c;
                }
            }
            return [];
        },

        getRecentTopics: function () {
            var out = [];
            var seen = {};
            for (var i = exchanges.length - 1; i >= 0 && out.length < 6; i -= 1) {
                var topic = exchanges[i].primaryEntity || exchanges[i].title;
                if (topic && !seen[topic]) {
                    seen[topic] = true;
                    out.push(topic);
                }
                (exchanges[i].followUpTopics || []).forEach(function (t) {
                    if (out.length >= 6) { return; }
                    if (!seen[t]) {
                        seen[t] = true;
                        out.push(t);
                    }
                });
            }
            return out;
        },

        getRecentQuestions: function () {
            return exchanges.slice(-5).map(function (ex) { return ex.query; });
        },

        getLastRetrieval: function () {
            for (var i = exchanges.length - 1; i >= 0; i -= 1) {
                if (exchanges[i].retrieval) {
                    return exchanges[i].retrieval;
                }
            }
            return null;
        },

        getLastAnswer: function () {
            for (var i = exchanges.length - 1; i >= 0; i -= 1) {
                if (exchanges[i].answer) {
                    return exchanges[i].answer;
                }
            }
            return null;
        },

        /**
         * Build the context object consumed by searchKnowledge / composeAnswer.
         */
        buildContext: function () {
            return {
                active: exchanges.length > 0,
                primaryEntity: this.getPrimaryEntity(),
                entities: this.getEntities(),
                category: this.getRecentCategory(),
                categories: exchanges.map(function (ex) { return ex.category; }).filter(Boolean),
                documents: exchanges.map(function (ex) { return ex.documentIds || []; }).reduce(function (a, b) { return a.concat(b); }, []),
                recentTopics: this.getRecentTopics(),
                recentQuestions: this.getRecentQuestions(),
                comparisonEntities: this.getComparisonEntities()
            };
        },

        clear: function () {
            exchanges = [];
        }
    };
}

module.exports = {
    createConversation: createConversation,
    MAX_EXCHANGES: MAX_EXCHANGES
};
